import React, { useContext, useEffect, useState } from 'react'

import { firestore } from '../../firebase'

import StateContext from '../../StateContext'

function FavoriteTeam({teamId, team}) {

    const appState = useContext(StateContext)

    const [added, setAdded] = useState(false)
    const [favId, setFavId] = useState()

    useEffect(() => {

        try {
            const favRef = firestore.collection("users").doc(appState.userId).collection("favoriteTeams");
            favRef.where("team_id", "==", teamId).onSnapshot(({docs}) => {

                const isAdded = docs.map(doc => {
                    return {id: doc.id, ...doc.data()}
                })

                if (isAdded && isAdded[0]) {
                    setAdded(true)
                    setFavId(isAdded[0].id)
                }
            })

        } catch (error) {
            
        }


    }, [teamId, setAdded])

    async function favoriteHandler(e) {
        e.preventDefault();
        try {
            const favRef = firestore.collection("users").doc(appState.userId).collection("favoriteTeams");

            const data = {
                team_id: teamId,
                team_logo: team.team_logo,
                team_name: team.team_name
            }
            favRef.add(data);
            setAdded(true)
        } catch (error) {
            
        }
    }

    async function removeFavoriteHandler(e) {
        e.preventDefault();
        try {
            console.log(favId)
            const favRef = firestore.collection("users").doc(appState.userId).collection("favoriteTeams").doc(favId);
            favRef.delete();
            setAdded(false)
            console.log("Deleted")
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <>  
            {!added ? (
                <form onSubmit={favoriteHandler}>
                    <button className="button-transparent"><i className={added ? "fas fa-star text-warning" : "fas fa-star"}></i></button>
                </form>
            )
            :
                <form onSubmit={removeFavoriteHandler}>
                    <button className="button-transparent"><i className={added ? "fas fa-star text-warning" : "fas fa-star"}></i></button>
                </form>
            }


        </>
    )
}
export default FavoriteTeam